NtechApp.ContactUs = function($view) { 
    var me = this;

    this._$view = null;
    this._touchClickEvent = null;
    this._ajax = null;
    this._formDataParser = null;

    this._$contactForm = null;
    this._$formSubmitButton = null;
    this._$formLoader = null;
    this._isSaving = false;

    this._userCookie = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        me._$view = $view;
        me._touchClickEvent = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();
        me._formDataParser = new NtechApp.FormDataParser();

        me._$contactForm = me._$view.find("form");
        me._$formSubmitButton = me._$view.find(".submitButton input");
        me._$formLoader = me._$view.find(".submitButton .buttonLoader");

        //me._scheduleLoadUserCookie();
        me._bindEvents();
    }

    this._bindEvents = function () {
        me._$contactForm.submit(function(event) {
            event.preventDefault();
            me._saveForm();

            return false;
        });

        var click = new NtechApp.TouchClickEvent();
        click.listen(me._$view, ".formErrors", function(e) {
            var $item = $(e.target).closest(".formErrors");
            $item.css("display", "none");
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ContactUs.prototype._enableLoader = function() {
    this._$view.find(".buttonLoader").css("display", "block");
};

NtechApp.ContactUs.prototype._disableLoader = function() {
    this._$view.find(".buttonLoader").css("display", "none");
};

NtechApp.ContactUs.prototype._scheduleLoadUserCookie = function() {
    var me = this;
    setTimeout(function() { me._loadUserCookie.call(me); }, 3000);
};

NtechApp.ContactUs.prototype._loadUserCookie = function() {
    var me = this;

    this._ajax.get({
        url: Routing.generate("load_user_cookie", {fid: "contacts"}),
        onSuccess: function(data) {
            me._userCookie = data.userCookie;
        }
    });
};

NtechApp.ContactUs.prototype._saveForm = function() { 
    //this._enableLoader();
    var me = this;
    var $submit = this._$view.find(":submit"); 

    if(this._isSaving)
        return;

    this._ajax.enableTextLoading($submit, true);
    this._isSaving = true;

    var formData = this._formDataParser.getFormJSON(this._$contactForm);
    if(formData.name.length == 0) {
        NtechApp.info.on("Error: please enter name.");
        me._ajax.disableTextLoading($submit, true);
        me._isSaving = false;
        $submit.val("Submit");
        return;
    }
    if(formData.email.length == 0) {
        NtechApp.info.on("Error: please enter email.");
        me._ajax.disableTextLoading($submit, true);
        me._isSaving = false;
        $submit.val("Submit");
        return;
    }
    if(formData.description.length == 0) {
        NtechApp.info.on("Error: please enter description.");
        me._ajax.disableTextLoading($submit, true);
        me._isSaving = false;
        $submit.val("Submit");
        return;
    }

    this._ajax.post({
        url: "/submit.php",
        data: formData,
        onSuccess: function(data) {
            //me._$view.find(".buttonLoader").html("MESSAGE SENT!").css("display", "block");
            NtechApp.info.on("Message sent!", 2500);
            setTimeout(function() {
                window.location.reload(true);
            }, 1500);
        },
        onComplete: function() {
            //me._disableLoader();
            me._ajax.disableTextLoading($submit, true);
            me._isSaving = false;
            $submit.val("Submit");
        },
        onError: function(errs) {
            var $errs = me._$view.find(".formErrors");
            $errs.css("display", "block");

            var $body = $errs.find(".errorBody");
            $body.find("p").remove();

            for(var errName in errs) {
                var err = errs[errName];
                $body.append($("<p/>").text(err));
            }
        }
    });
};